/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PaymentChannel = {
    ANDROID: 'ANDROID',
    IOS: 'IOS',
    WEB: 'WEB'
} as const;
export type PaymentChannel = typeof PaymentChannel[keyof typeof PaymentChannel];


export function instanceOfPaymentChannel(value: any): boolean {
    for (const key in PaymentChannel) {
        if (Object.prototype.hasOwnProperty.call(PaymentChannel, key)) {
            if (PaymentChannel[key as keyof typeof PaymentChannel] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PaymentChannelFromJSON(json: any): PaymentChannel {
    return PaymentChannelFromJSONTyped(json, false);
}

export function PaymentChannelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentChannel {
    return json as PaymentChannel;
}

export function PaymentChannelToJSON(value?: PaymentChannel | null): any {
    return value as any;
}

export function PaymentChannelToJSONTyped(value: any, ignoreDiscriminator: boolean): PaymentChannel {
    return value as PaymentChannel;
}

